(function () {
  'use strict';

  window.theme = window.theme || {};

  if (window.theme.quicklinksGrabScroll) {
    window.theme.quicklinksGrabScroll.initAll(document);
    return;
  }

  var selector = '[data-quicklinks-grab-scroll]';
  var initializedAttribute = 'data-quicklinks-grab-scroll-initialized';
  var draggingClass = 'is-grab-scrolling';
  var dragThreshold = 12;

  function initScroller(scroller) {
    if (!scroller || scroller.hasAttribute(initializedAttribute)) {
      return;
    }

    scroller.setAttribute(initializedAttribute, 'true');

    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var isDragging = false;
    var suppressClick = false;

    function stopDrag(event) {
      if (pointerId === null || (event && event.pointerId !== pointerId)) {
        return;
      }

      if (scroller.releasePointerCapture && scroller.hasPointerCapture && scroller.hasPointerCapture(pointerId)) {
        scroller.releasePointerCapture(pointerId);
      }

      pointerId = null;
      startX = 0;
      startY = 0;
      startScrollLeft = 0;
      scroller.classList.remove(draggingClass);

      if (isDragging) {
        window.setTimeout(function () {
          suppressClick = false;
        }, 120);
      } else {
        suppressClick = false;
      }

      isDragging = false;
    }

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') {
        return;
      }

      if (typeof event.button === 'number' && event.button !== 0) {
        return;
      }

      if (scroller.scrollWidth <= scroller.clientWidth) {
        return;
      }

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = scroller.scrollLeft;
      isDragging = false;
      suppressClick = false;
    });

    scroller.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) {
        return;
      }

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;

      if (!isDragging) {
        if (Math.abs(deltaX) < dragThreshold) {
          return;
        }

        if (Math.abs(deltaX) < Math.abs(deltaY)) {
          return;
        }

        isDragging = true;
        suppressClick = true;
        scroller.classList.add(draggingClass);

        if (scroller.setPointerCapture && (!scroller.hasPointerCapture || !scroller.hasPointerCapture(pointerId))) {
          scroller.setPointerCapture(pointerId);
        }
      }

      scroller.scrollLeft = startScrollLeft - deltaX;
      event.preventDefault();
    });

    scroller.addEventListener('pointerup', stopDrag);
    scroller.addEventListener('pointercancel', stopDrag);

    scroller.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    scroller.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var scrollers = scope.querySelectorAll(selector);

    scrollers.forEach(initScroller);
  }

  window.theme.quicklinksGrabScroll = {
    initAll: initAll
  };

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
